import { useCallback } from 'react'
import { setAllMainSelection } from '@/atoms'

export function useSelectRoutes(routeIds: string[]) {
  return useCallback(
    () => setAllMainSelection({ routes: routeIds, unifiedVehicles: [] }),
    [routeIds],
  )
}
